import * as React from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import { TENANT } from '../constants';
import { isLoggedIn } from '../utils/authentication';
import { withDefaultStyles } from '../utils/material-ui/hoc';

class ProjectSelector extends React.Component<any, any> {
  public render() {
    return (
      <div style={this.props.style}>
        <Select
          isDisabled={!isLoggedIn(this.props.authentication)}
          defaultValue={{
            value: TENANT.NO_TENANT,
            label: TENANT.NO_TENANT_NAME}}
          value={{
            value: this.props.tenant.id,
            label: this.props.tenant.name
          }}
          onChange={this.handleProjectChange}
          options={this.props.projects}
        />
      </div>
    );
  }
  private handleProjectChange = (selectedOption) => {
    this.props.onProjectChange(selectedOption.value, selectedOption.label);
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}


export default withDefaultStyles(connect(
  mapStateToProps,
)(ProjectSelector));



// WEBPACK FOOTER //
// ./src/components/project-selector.tsx